import React from 'react'
import { connect } from 'react-redux'
import {
    Button,
    Classes,
    Dialog,
    Label,
    TextArea,
    InputGroup,
    Tag,
} from '@blueprintjs/core'

import { getAction } from 'src/store/modules/runbooks/actions'

class AddDecisionDialog extends React.Component {
    componentDidMount() {
        if (this.props.decision) {
            this.setState({ decision: this.props.decision })
        }
        if (this.props.reasoning) {
            this.setState({ reasoning: this.props.reasoning })
        }
        if (this.props.id) {
            this.setState({ id: this.props.id })
        }
        if (this.props.owner) {
            this.setState({ owner: this.props.owner })
        }
    }

    state = {
        id: null,
        decision: '',
        reasoning: '',
        owner: '',
    }

    handleCreateClick = () => {
        this.props.handleConfirm({
            id: this.state.id,
            owner: this.state.owner,
            decision: this.state.decision,
            reasoning: this.state.reasoning,
            actionUid: this.props.fromAction,
        })
        this.props.handleClose()
    }

    render() {
        const { handleClose, action } = this.props
        return (
            <Dialog
                onClose={handleClose}
                title="Log a decision"
                isOpen={true}
                canOutsideClickClose={false}
            >
                <div className={Classes.DIALOG_BODY}>
                    {action ? (
                        <React.Fragment>
                            <div style={{ marginBottom: 5 }}>Action</div>
                            <Tag style={{ marginRight: 5 }}>{action.uid}</Tag>
                            <Tag style={{ marginBottom: 15 }} intent="danger">
                                {action.name}
                            </Tag>
                        </React.Fragment>
                    ) : null}
                    <Label>
                        Owner
                        <InputGroup
                            value={this.state.owner}
                            maxLength={128}
                            onChange={(e) =>
                                this.setState({ owner: e.target.value })
                            }
                        />
                    </Label>
                    <Label>
                        Decision
                        <TextArea
                            fill={true}
                            onChange={(e) =>
                                this.setState({ decision: e.target.value })
                            }
                            value={this.state.decision}
                            maxLength={128}
                        />
                    </Label>
                    <Label>
                        Reasoning
                        <TextArea
                            fill={true}
                            onChange={(e) =>
                                this.setState({ reasoning: e.target.value })
                            }
                            value={this.state.reasoning}
                            maxLength={128}
                        />
                    </Label>
                </div>
                <div className={Classes.DIALOG_FOOTER}>
                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button
                            intent="primary"
                            large
                            disabled={
                                !this.state.owner ||
                                !this.state.decision ||
                                !this.state.reasoning
                            }
                            onClick={this.handleCreateClick}
                        >
                            Save
                        </Button>
                        <Button
                            intent="lynch-underline"
                            large
                            onClick={handleClose}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </Dialog>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    if (ownProps.fromAction) {
        return {
            // TODO: refactor this once actions are asynchronously fetched.
            action: getAction(
                state,
                state.ui.runbook.activeRunbook,
                ownProps.fromAction
            ),
        }
    }
    return {}
}

export default connect(mapStateToProps)(AddDecisionDialog)
